var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBombersLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 81,
    viewBox: "0 0 106 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.2591 3.33545V21.2694H78.2393L73.0573 48.1768L62.3962 3.33545H43.6068L32.9457 48.1768L27.7637 21.2694H31.7568V3.33545H4.05078V21.2694H9.11643L21.6384 76.8993H41.074L53.0015 32.1986L64.929 76.8993H84.3646L96.8866 21.2694H101.965V3.33545H74.2591Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8724 -0.000488281V24.3759L65.0702 -0.000488281H40.9308L35.1286 24.3759V-0.000488281H0.664062V24.6188H6.41461L18.9366 80.2487H43.6704L53.0005 45.2883L62.3306 80.2487H87.0644L99.5864 24.6188H105.337V-0.000488281H70.8724ZM74.1548 24.6188L72.7204 32.1222L70.9241 24.6188H74.1548ZM35.0769 24.6188L33.2936 32.1222L31.8463 24.6188H35.0769ZM101.964 21.2698H96.8856L84.3636 76.8997H64.9798L53.0522 32.1606L41.1247 76.8997H21.7408L9.11543 21.2698H4.03686V3.37412H31.7558V21.2698H27.8015L32.9705 48.1132L43.6058 3.33577H62.3952L73.0305 48.1772L78.1996 21.3337H74.2452V3.43803H101.964V21.2698Z",
    fill: "#233574"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9258 77.1034H89.9854V80.2479H90.3602V77.1034H91.4715V76.7327H88.9258V77.1034Z",
    fill: "#233574"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4995 79.596L92.5949 76.7327H91.9746V80.2479H92.3623V77.2568L93.3185 80.2479H93.6933L94.6496 77.2568V80.2479H95.0243V76.7327H94.417L93.4995 79.596Z",
    fill: "#233574"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBombersLogo);
export default __webpack_public_path__ + "static/media/bombers_logo.7f0a8702e75a91cb88b3d1158726248e.svg";
export { ForwardRef as ReactComponent };